import { render, staticRenderFns } from "./memberDetails.vue?vue&type=template&id=33298970&scoped=true&"
import script from "./memberDetails.vue?vue&type=script&lang=js&"
export * from "./memberDetails.vue?vue&type=script&lang=js&"
import style0 from "./memberDetails.vue?vue&type=style&index=0&id=33298970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33298970",
  null
  
)

export default component.exports